module.exports = __webpack_public_path__ + "static/media/heading-magazinepublicacions.d77d9104.jpg";